// extracted by mini-css-extract-plugin
export default {"root":"styles-scoped__root--TGc0F","border":"styles-scoped__border--Q49sL","itemComponent":"styles-scoped__itemComponent--F3yIm"};